const copyLink = () => {
  const element = document.createElement('input');
  element.value = location.href;
  document.body.appendChild(element);
  element.select();
  document.execCommand('copy');
  document.body.removeChild(element);
};

const showSnackbar = () => {
  $('#snackbar')
    .fadeIn('normal', function () {
      $(this).delay(2000).fadeOut('normal');
    })
    .css('display', 'flex');
};

window.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName('js_copy_link_button');
  if (elements) {
    Array.from(elements).forEach((element) => {
      element.addEventListener('click', () => {
        copyLink();
        showSnackbar();
      });
    });
  }
});
